import { render, staticRenderFns } from "./500.vue?vue&type=template&id=51056a48&scoped=true"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"
import style0 from "./500.vue?vue&type=style&index=0&id=51056a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51056a48",
  null
  
)

export default component.exports